import crudActions from '../../crud/actions'

const actions = crudActions('CARE_OUTCOMES_')

export default actions
